// extracted by mini-css-extract-plugin
export default {"kvLabel":"kvLabel---B6S8V","kvRoot":"kvRoot---wWoSB","kvValue":"kvValue---kU4It","kvSub":"kvSub---AFwy1"};